//react
import React from "react"
// material-ui
import FlatButton from "material-ui/FlatButton"

const Edit = ({
    onEdit = () => {},
    disabled = false
}) =>
    <FlatButton
        key="edit"
        label="Edit"
        primary={ true }
        onTouchTap={ onEdit }
        disabled={ disabled }
    />

export default Edit


/** WEBPACK FOOTER **
 ** ./src/components/common/buttons/Edit/edit.js
 **/